import { FC, ReactNode, useRef } from 'react';
import { Modal, Popover } from 'antd';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { IPOIcon, IPOIcons, IPOUtils } from '@hylaa-npm/ipod';

import { toProjectDetail, toProjectOverview } from '../../utils';
import closeIcon from '@/images/common/close.svg';

import { OverviewModalWrap, ProjectRemoveNameSpan } from './style';
export interface IOverview {
	projectId: string;
	client: ISplitEnd;
	handleClose?: () => void;
}

export const Status: FC<{ status: string }> = ({ status }) => {
	let name: string = '-';
	let icon: string = '';

	const projectStatus = IPOUtils.projectStatus.filter((item) => item.key === status);
	if (projectStatus[0]) {
		name = projectStatus[0].name;
		icon = projectStatus[0].icon;
	}

	return (
		<>
			<IPOIcon src={icon} width={26} height={26}></IPOIcon>
			<span>{name}</span>
		</>
	);
};

export const Time: FC<{ startTime: number; endTime: number }> = ({ startTime, endTime }) => {
	return (
		<span>
			{startTime ? dayjs(startTime).format('YYYY-MM-DD') : ''} -
			{endTime ? dayjs(endTime).format('YYYY-MM-DD') : ''}
		</span>
	);
};

export const Name: FC<{
	id: string;
	name: string;
	client: ISplitEnd;
	isJumpRight?: boolean;
	isCurrentPro?: boolean;
}> = ({ id, name, client, isJumpRight, isCurrentPro }) => {
	isJumpRight = isJumpRight ?? false;
	isCurrentPro = isCurrentPro ?? true;
	const { t } = useTranslation();
	return (
		<span onClick={() => isJumpRight && toProjectDetail(client, id, true)}>
			{name ? name : '-'}
			{!isCurrentPro && <ProjectRemoveNameSpan>({t('project.removed')})</ProjectRemoveNameSpan>}
		</span>
	);
};

export const Overview: FC<{ projectId: string; client: ISplitEnd }> = ({ projectId, client }) => {
	return (
		<div
			onClick={(e) => {
				e.stopPropagation();
				window.eventEmitter.emit('projectInfo', { projectId, client });
			}}>
			<IPOIcon src={IPOIcons.tableIcon} width={30} height={30}></IPOIcon>
		</div>
	);
};

export const Client: FC<{ client: ISplitEnd }> = ({ client }) => {
	const { t } = useTranslation();
	const getCardEle: (client: ISplitEnd) => ReactNode = (client) => {
		return (
			<div className="client-card">
				<div className="client-line">
					<div className="left-name">{t('printer.name')}：</div>
					<div className="right-content">{client.name}</div>
				</div>
				<div className="client-line">
					<div className="left-name">{t('printer.domainName')}：</div>
					<div className="right-content">{client.url}</div>
				</div>
			</div>
		);
	};

	return (
		<Popover
			content={getCardEle(client)}
			title={t('printer.splitServerIinfo')}
			getPopupContainer={() => document.getElementById('project-wrap') as HTMLElement}>
			{client.name ? client.name : '-'}
		</Popover>
	);
};

export const OverviewModal: FC<IOverview> = ({ projectId, client, handleClose }) => {
	const { t } = useTranslation();
	const contentIFrameRef = useRef<HTMLIFrameElement>(null);

	return (
		<OverviewModalWrap>
			<Modal
				maskClosable={false}
				title={t('project.projectOverview')}
				closeIcon={<img src={closeIcon} />}
				visible={!!projectId}
				footer={null}
				width={'80%'}
				getContainer={false}
				onCancel={() => handleClose && handleClose()}
				style={{ height: '100vh', top: 0 }}>
				<iframe ref={contentIFrameRef} src={toProjectOverview(client, projectId)} />
			</Modal>
		</OverviewModalWrap>
	);
};

export const FilterProjectId: (projects: IProject[]) => IProject[] = (projects) => {
	let newProjects: IProject[] = [];
	newProjects = projects.filter((item) => item.id);
	return newProjects;
};

export const projectIsRemove: (teamState: 0 | 1, temMemberState: 0 | 1) => boolean = (
	teamState,
	temMemberState,
) => {
	if (teamState === 0 || temMemberState === 0) {
		return true;
	} else {
		return false;
	}
};
